<template>
  <v-dialog v-model="dialog" max-height="300px" width="600px">
    <v-card rounded-0 flat class="white pa-6">
      <div class="d-flex justify-end">
        <v-icon @click="hide"> mdi-close </v-icon>
      </div>
      <v-container>
        <p class="title">Hier sind ein paar Neuigkeiten zu Anfragen oder Angeboten an denen Du beteiligt bist!</p>

        <v-label v-if="requestNotifications.length > 0">Anfragen-Updates</v-label>
        <v-list v-if="requestNotifications.length > 0" class="mb-5">
          <v-list-item v-for="notification in requestNotifications" class="d-flex align-start">
            <v-col cols="6" class="d-flex flex-column" v-if="notification.productionRequest">
              <p class="request-title" @click="hide()">
                <RouterLink
                  :to="`/my-production-requests`"
                >
                  {{ notification.productionRequest.title }}
                </RouterLink>
              </p>
              <v-row class="d-flex align-center pt-1" v-if="notification.offer && notification.offer.customer">
                <v-img
                        v-if="notification.offer.customer.picture_file_path"
                        class="customer-img rounded-circle ml-4"
                        contain
                        height="32"
                        width="32"
                        :src="notification.offer.customer.picture_file_path"
                        alt="customer"
                  />
                  <v-icon v-else class="customer-img rounded-circle ml-4" size="30">
                    mdi-account-outline
                  </v-icon>
                  <span class="ml-4">
                    {{ notification.offer.customer.name }}
                    <p class="mb-0 notification-date">{{ notification.created_at | moment("DD.MM.YYYY hh:mm")}}</p>
                  </span>
              </v-row>
            </v-col>
            <v-col cols="6">
              <p>
                {{getMessage(notification)}}
              </p>
            </v-col>
          </v-list-item>
        </v-list>

        <v-label v-if="offerNotifications.length > 0">Angebots-Updates</v-label>
        <v-list v-if="offerNotifications.length > 0">
          <v-list-item v-for="notification in offerNotifications" class="d-flex align-start">
            <v-col cols="6" class="d-flex flex-column" v-if="notification.productionRequest">
              <p class="request-title" @click="hide()">
                <RouterLink
                  :to="`/marketplace/${notification.productionRequest.id}`"
                >
                  {{ notification.productionRequest.title }}
                </RouterLink>
              </p>
              <v-row class="d-flex align-center pt-1"  v-if="notification.productionRequest && notification.productionRequest.customer">
                <v-img
                        v-if="notification.productionRequest.customer.picture_file_path"
                        class="customer-img rounded-circle ml-4"
                        contain
                        height="32"
                        width="32"
                        :src="notification.productionRequest.customer.picture_file_path"
                        alt="customer"
                  />
                  <v-icon v-else class="customer-img rounded-circle ml-4" size="30">
                    mdi-account-outline
                  </v-icon>
                  <span class="ml-4">
                    {{ notification.productionRequest.customer.name }}
                    <p class="mb-0 notification-date">{{ notification.created_at | moment("DD.MM.YYYY hh:mm")}}</p>
                  </span>
              </v-row>
            </v-col>
            <v-col cols="6">
              <p>
                {{getMessage(notification)}}
              </p>
            </v-col>
          </v-list-item>
        </v-list>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import logo from '../../../assets/manushare.png'
import { mapActions, mapState } from 'vuex'

export default {
	name: 'UserNotifications',
	props: {
		currentUser: Object
	},
	data: () => ({
		dialog: false,
		requestNotifications: [],
		offerNotifications: [],
		requestTypes: [
			{ type: 'received nda', text: 'Du hast eine neue Geheimhaltungsvereinbarung zur Anfrage - [request] - erhalten' },
			{ type: 'received offer', text: 'Gute Nachrichten! Du hast ein neues Angebot zur Anfrage - [request] - erhalten. Möchtest Du es annehmen?' },
			{ type: 'offer updated', text: 'Du hast eine Angebotsaktualisierung zur Anfrage - [request] - erhalten. Möchtest Du es annehmen?' },
			{ type: 'offer period reached', text: 'Die Angebotsfrist zur Anfrage - [request] - ist heute erreicht. Prüfe Deine eingegangenen Angebote.' },
			{ type: 'day before offer expiration', text: 'Die Gültigkeit eines Angebots zur Anfrage - [request] - läuft Morgen ab. Möchtest Du es annehmen?' }
		],
		offerTypes: [
			{ type: 'nda accepted', text: 'Deine Geheimhaltungsvereinbarung zur Anfrage - [request] - wurde akzeptiert. Gib jetzt Dein Angebot ab.' },
			{ type: 'nda declined', text: ' Leider hat es diesmal nicht geklappt. Deine Geheimhaltungsvereinbarung zur Anfrage - [request] - wurde abgelehnt.' },
			{ type: 'offer accepted', text: 'Herzlichen Glückwunsch! Dein Angebot zur Anfrage - [request] - wurde akzeptiert' },
			{ type: 'offer declined', text: 'Leider hat es diesmal nicht geklappt. Dein Angebot zur Anfrage - [request] - wurde abgelehnt' },
			{ type: 'production request updated', text: 'Achtung! Die Anfrage - [request] - wurde aktualisiert. Bitte prüfe Dein Angebot auf Gültigkeit.' },
			{ type: 'day before offer expiration', text: 'Dein Angebot zur Anfrage - [request] - erreicht morgen seine Gültigkeit. Möchtest du sie verlängern?' }
		]
	}),
	computed: {
		...mapState({
			user: (state) => state.auth.user,
			notifications: (state) => state.userNotifications.items
		})
	},
	created () {
		this.list({ params: [this.user.id] }).then(() => {
			this.setRequestNotifications()
			this.setOfferNotifications()
			this.countUnreadNotifications()
		})
	},
	methods: {
		...mapActions({
			list: 'userNotifications/list',
			put: 'userNotifications/put'
		}),

		setRequestNotifications () {
			this.requestNotifications = this.notifications.filter(
				(notification) => this.requestTypes.map(a => a.type).indexOf(notification.type) >= 0
			)
		},
		setOfferNotifications () {
			this.offerNotifications = this.notifications.filter(
				(notification) => this.offerTypes.map(a => a.type).indexOf(notification.type) >= 0
			)
		},
		getMessage (notification) {
			const types = this.offerTypes.concat(this.requestTypes)
			const message = types.find(e => e.type == notification.type).text
			return message.replace('[request]', notification.productionRequest.title)
		},
		async setMessagesOnRead () {
			await this.notifications
			this.notifications.forEach(notification => {
				this.put({
					params: [this.currentUser.id, notification.id],
					data: { read_at: Date.now() }
				})
			})
		},
		show () {
			this.dialog = true
			this.setMessagesOnRead()
			this.$emit('unreadNotification', 0)
		},
		hide () {
			this.dialog = false
		},
		countUnreadNotifications () {
			const unreadNotifications = this.notifications.filter((notification) => {
				return notification.read_at == null
			})
			this.$emit('unreadNotification', unreadNotifications.length)
		}
	},
	watch: {
		notifications () {
			this.setRequestNotifications()
			this.setOfferNotifications()
		}
	}
}
</script>

<style scoped>
  .customer-img{
    max-width: 32px;
    border: 0.5px solid #667085;
  }
  p, h2, span{
    font-family: 'Karla';
    font-style: normal;
    color: #303941;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
  }
  .title{
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    color: #303941;
  }
  .request-title{
    text-decoration-line: underline;
  }
  .v-label{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #303941;
  }
  .v-list-item{
    border: 1px solid #EEEEEE;
  }
  .notification-date{
    font-size: 10px;
    color: #667085;
  }

</style>
